import { EditableContent } from '../../edit/EditableContent';
import { pickBlockField } from '../../lib/localized';
import { parseRouteStops } from '../../lib/parseLabeledLines';
import type { BlockRenderProps } from '../../types';

export function WeeklyScheduleRouteStrip({
  block,
  locale,
  isActive,
  activeEditTarget,
  editable,
}: BlockRenderProps) {
  const sectionTitle = pickBlockField(block.content, 'sectionTitle', locale);
  const supporting = pickBlockField(block.content, 'supporting', locale);
  const scheduleRaw = pickBlockField(block.content, 'schedule', locale);
  const rows = parseRouteStops(scheduleRaw);
  const target = isActive ? activeEditTarget : null;

  return (
    <section
      className={['ws-week-schedule', isActive ? 'ws-block--active' : '']
        .filter(Boolean)
        .join(' ')}
      data-block-id={block.blockId}
      data-component={block.componentType}
      id="schedule"
    >
      <div className="ws-week-schedule__inner">
        <EditableContent
          as="h2"
          fieldKey="sectionTitle"
          editable={editable}
          activeEditTarget={target}
          className="ws-week-schedule__title"
        >
          {sectionTitle}
        </EditableContent>
        {supporting || editable ? (
          <EditableContent
            fieldKey="supporting"
            editable={editable}
            activeEditTarget={target}
            className="ws-week-schedule__supporting"
          >
            {supporting}
          </EditableContent>
        ) : null}
        {editable ? (
          <EditableContent
            fieldKey="schedule"
            editable={editable}
            activeEditTarget={target}
            className="ws-week-schedule__editor"
          >
            {scheduleRaw}
          </EditableContent>
        ) : (
          <ul className="ws-week-schedule__list">
            {rows.map((row, index) => (
              <li key={`${row.day}-${index}`} className="ws-week-schedule__row">
                <span className="ws-week-schedule__day">{row.day}</span>
                {row.place ? (
                  row.href ? (
                    <a
                      className="ws-week-schedule__place"
                      href={row.href}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {row.place}
                    </a>
                  ) : (
                    <span className="ws-week-schedule__place">{row.place}</span>
                  )
                ) : null}
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
}
